import { Pipe, PipeTransform } from '@angular/core';
import { GlobalService } from '../services/global.service';

@Pipe({
    name: 'access',
    standalone: false
})
export class AccessPipe implements PipeTransform {

	constructor(private _gS: GlobalService) { }

	transform(data: { id: number, type: string }): boolean {
		return this._gS.validateAcces(data);
	}

}
